import { featureFlagGuard } from '@tundr/feature-flags';
import type { RouteRecordRaw } from 'vue-router';
import { welfareAssignmentsRoutesDictionary } from './welfare-assignments-routes.dictionary.ts';

export const welfareAssignmentsRoutesConfig: RouteRecordRaw = {
  ...welfareAssignmentsRoutesDictionary.welfareAssignments.root,
  redirect: {
    name: welfareAssignmentsRoutesDictionary.welfareAssignments.list.name,
  },
  children: [
    {
      ...welfareAssignmentsRoutesDictionary.welfareAssignments.list,
      component: () =>
        import('../pages/WelfareAssignment/List/WelfareAssignmentListPage.vue'),
    },
    {
      ...welfareAssignmentsRoutesDictionary.welfareAssignments.detail,
      component: () =>
        import(
          '../pages/WelfareAssignment/Detail/WelfareAssignmentDetailPage.vue'
        ),
      props: true,
    },
    {
      ...welfareAssignmentsRoutesDictionary.welfareAssignments.edit,
      component: () =>
        import('../pages/WelfareAssignment/Edit/WelfareAssignmentEditPage.vue'),
      props: true,
    },
    {
      ...welfareAssignmentsRoutesDictionary.welfareAssignments
        .completePlanDetail,
      beforeEnter: featureFlagGuard(
        'cancel-welfare-source.bo.feature.complete-plan-assignment-detail.release',
        {
          redirect: {
            name: welfareAssignmentsRoutesDictionary.welfareAssignments.list
              .name,
          },
        },
      ),
      component: () =>
        import(
          '../pages/CompletePlanAssignment/Detail/CompletePlanAssignmentDetailPage.vue'
        ),
      props: true,
    },
    {
      ...welfareAssignmentsRoutesDictionary.welfareAssignments.completePlanEdit,
      beforeEnter: featureFlagGuard(
        'cancel-welfare-source.bo.feature.complete-plan-assignment-detail.release',
        {
          redirect: {
            name: welfareAssignmentsRoutesDictionary.welfareAssignments.list
              .name,
          },
        },
      ),
      component: () =>
        import(
          '../pages/CompletePlanAssignment/Edit/CompletePlanAssignmentEditPage.vue'
        ),
      props: true,
    },
    {
      ...welfareAssignmentsRoutesDictionary.welfareAssignments
        .mealVoucherDetail,
      component: () =>
        import(
          '../pages/MealVoucherAssignment/Detail/MealVoucherAssignmentDetailPage.vue'
        ),
      props: true,
    },
  ],
};
